/** E-mail one-time code sign-in. */
import { useState } from "react";
import { api } from "../lib/api.ts";
import { Crew } from "../components/Crew.tsx";

export function Login({ onDone }: { onDone: () => void }) {
  const [email, setEmail] = useState(""), [code, setCode] = useState(""), [step, setStep] = useState<"email" | "code">("email");
  const [busy, setBusy] = useState(false), [err, setErr] = useState<string | null>(null), [dev, setDev] = useState<string | null>(null);
  const submit = async () => {
    setBusy(true); setErr(null);
    try {
      if (step === "email") { const r = await api<{ devCode?: string }>("/auth/otp/start", { method: "POST", body: { email } }); setDev(r.devCode ?? null); setStep("code"); }
      else { await api("/auth/otp/verify", { method: "POST", body: { email, code } }); onDone(); }
    } catch (e) { setErr((e as Error).message); } finally { setBusy(false); }
  };
  return (
    <main className="flex min-h-screen items-center justify-center px-4">
      <form className="card flex w-full max-w-[380px] flex-col gap-4 p-7" onSubmit={(e) => { e.preventDefault(); void submit(); }}>
        <div className="flex items-center gap-2.5"><Crew character="nebula" size={34} /><span className="text-[22px] font-bold tracking-[-0.02em] text-ink-strong">Dukun</span></div>
        <div>
          <h1 className="m-0 text-[22px] font-semibold text-ink-strong">{step === "email" ? "Sign in" : "Check your e-mail"}</h1>
          <p className="m-0 mt-1 text-muted">{step === "email" ? "We'll send you a 6-digit code." : `Enter the code we sent to ${email}.`}</p>
        </div>
        {step === "email"
          ? <label className="flex flex-col gap-1.5"><span className="text-[13px] text-muted">E-mail</span><input className="input" type="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoFocus /></label>
          : <label className="flex flex-col gap-1.5"><span className="text-[13px] text-muted">Code</span><input className="input num text-[20px] tracking-[0.3em]" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]{6}" maxLength={6} required value={code} onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))} autoFocus /></label>}
        {dev && step === "code" && <p className="m-0 text-[13px] text-muted">Dev mode code: <span className="num">{dev}</span></p>}
        {err && <div role="alert" className="rounded-lg bg-warn-soft px-3 py-2 text-warn-ink">{err}</div>}
        <button className="btn-primary" disabled={busy}>{busy ? "Sending…" : step === "email" ? "Send code" : "Sign in"}</button>
        {step === "code" && <button type="button" className="text-[13px] text-muted underline" onClick={() => { setStep("email"); setCode(""); }}>Use another e-mail</button>}
      </form>
    </main>
  );
}
